import { render } from "./SearchWithCollapse.vue?vue&type=template&id=0b3dbee8&scoped=true"
import script from "./SearchWithCollapse.vue?vue&type=script&lang=js"
export * from "./SearchWithCollapse.vue?vue&type=script&lang=js"

import "./SearchWithCollapse.vue?vue&type=style&index=0&id=0b3dbee8&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3dbee8"]])

export default __exports__